/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        /* REVEAL ITEM UPON VIEW */
        // Declared here to use in multiple name spaces
        itemReveal: function () {
            var waypoints = $(".reveal").waypoint({
                handler: function (direction) {
                    $(this).addClass("revealed");
                },
                offset: "95%",
            });
        },
        /* END REVEAL ITEM UPON VIEW */

        // All pages
        common: {
            init: function () {
                // JavaScript to be fired on all pages

                /** GLOBAL VARIABLES */
                var body = document.querySelector("body");
                /** END GLOBAL VARIABLES */

                /** SKIP LINK NAVIGATION */
                $("#skip-to-content").click(function (event) {
                    // strip the leading hash and declare
                    // the content we're skipping to
                    var skipTo = "#" + this.href.split("#")[1];
                    // Setting 'tabindex' to -1 takes an element out of normal
                    // tab flow but allows it to be focused via javascript
                    $(skipTo)
                        .attr("tabindex", -1)
                        .on("blur focusout", function () {
                            // when focus leaves this element,
                            // remove the tabindex attribute
                            $(this).removeAttr("tabindex");
                        })
                        .focus(); // focus on the content container
                });
                /** END SKIP LINK NAVIGATION */

                /* MOBILE MENU KEYBOARD ACCESSIBILITY */
                var $mobileNavIcon = $("#mobile-nav-icon");

                // Sets aria-hidden to false when mobile view and nav icon is always present
                if ($(window).width() > 1199) {
                    $mobileNavIcon.attr("aria-hidden", "true");
                    $mobileNavIcon.attr("tabindex", -1);
                }
                var isMenuOpen = false;

                $mobileNavIcon.keypress(function (e) {
                    if ((e.keyCode ? e.keyCode : e.which) == 13) {
                        $("#nav-toggle").trigger("click");
                        $mobileNavIcon.toggleClass("mobile-active");

                        isMenuOpen = !isMenuOpen;
                        $mobileNavIcon.attr("aria-expanded", isMenuOpen);
                    }
                });
                /* END MOBILE MENU KEYBOARD ACCESSIBILITY */

                /* BACK LINKS */

                $("#back-link").on("click", function (e) {
                    e.preventDefault();
                    history.back();
                });

                /* END BACK LINKS */

                $("#mobile-nav-icon").on("click", function () {
                    $(this).toggleClass("mobile-active");
                });

                $(".video-modal-popup").magnificPopup({
                    type: "iframe",
                    iframe: {
                        markup:
                            '<div class="mfp-iframe-scaler">' +
                            '<div class="mfp-close"></div>' +
                            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                            '<div class="mfp-title">Some caption</div>' +
                            "</div>",
                    },
                });
                /* HEADER SCROLL EFFECT */
                // Reference: http://tympanus.net/codrops/2013/06/06/on-scroll-animated-header/
                var animatedHeader = (function () {
                    var didScroll = false,
                        scrollOffset = 80;

                    function scrollY() {
                        return (
                            window.pageYOffset ||
                            document.documentElement.scrollTop
                        );
                    }

                    function scrollPage() {
                        var sy = scrollY();
                        if (sy > scrollOffset) {
                            body.classList.add("scroll-triggered");
                            // When nav icon is visible, set aria hidden to false
                            $mobileNavIcon.attr("aria-hidden", "false");
                            $mobileNavIcon.attr("tabindex", 0);
                        } else {
                            body.classList.remove("scroll-triggered");
                            // Only if at largest screen size
                            if ($(window).width() > 1199) {
                                // When nav icon is hidden, set aria hidden to true
                                $mobileNavIcon.attr("aria-hidden", "true");
                                $mobileNavIcon.attr("tabindex", -1);
                            }
                        }
                        didScroll = false;
                    }

                    function init() {
                        window.addEventListener("load", scrollPage);
                        window.addEventListener(
                            "scroll",
                            function (event) {
                                if (!didScroll) {
                                    didScroll = true;
                                    scrollPage();
                                }
                            },
                            false
                        );
                    }
                    init();
                })();
                /* END HEADER SCROLL EFFECT */

                /** END MASTHEAD SCROLL ANIMATION **/

                /** RESPONSIVE NAV OPEN/CLOSE **/
                var mobileNav = document.querySelector("#mobile-nav");
                var mobileNavButton =
                    document.querySelector("#mobile-nav-icon");

                // Toggle menu icon
                if (mobileNavButton) {
                    mobileNavButton.addEventListener("click", function () {
                        if (hasScrollbar()) {
                            $("body").css("padding-right", "15px");
                            if ($(window).outerWidth() <= 768) {
                                $("#mobile-nav-icon").css("right", "44px");
                            } else {
                                $("#mobile-nav-icon").css(
                                    "right",
                                    "calc(6% + 14px)"
                                );
                            }
                        } else if ($("body").hasClass("mobile-nav-open")) {
                            $("body").css("padding-right", "0");
                            if ($(window).outerWidth() <= 768) {
                                $("#mobile-nav-icon").css("right", "30px");
                            } else {
                                $("#mobile-nav-icon").css("right", "6%");
                            }
                        }
                        body.classList.toggle("mobile-nav-open");
                    });
                }

                // Close menu if page is clicked (not menu item)
                if (mobileNav) {
                    mobileNav.addEventListener("click", function (e) {
                        // Don't hide if click is on a child element (nav link)
                        if (e.target !== this) {
                            return;
                        }
                        mobileNavButton.classList.toggle("opened");
                        $("#nav-toggle").prop("checked", false);
                    });
                }
                /** END RESPONSIVE NAV OPEN/CLOSE **/

                function hasScrollbar() {
                    // The Modern solution
                    return window.innerWidth > document.body.clientWidth;
                }

                /** SHOW AND HIDE SEARCH BAR **/
                var searchButton = $("#search-button"),
                    headerMain = $("#header-main"),
                    headerSearch = $("#header-search"),
                    searchClose = $("#search-close");

                searchButton.click(function () {
                    headerMain.fadeToggle("fast", function () {
                        headerSearch.fadeToggle("slow");
                        // Focus on input for all browsers except IE11. They have a placeholder text bug.
                        if (
                            window.ActiveXObject &&
                            !("ActiveXObject" in window)
                        ) {
                            headerSearch.find('input[type="text"]').focus();
                        }
                    });
                    return false;
                });
                searchClose.click(function () {
                    headerSearch.fadeToggle("fast", function () {
                        headerMain.fadeToggle("slow");
                    });
                });
                // Shake Animation
                function shake(div) {
                    var interval = 100;
                    var distance = 10;
                    var times = 4;
                    $(div).css("position", "relative");
                    for (var iter = 0; iter < times + 1; iter++) {
                        $(div).animate(
                            { left: iter % 2 === 0 ? distance : distance * -1 },
                            interval
                        );
                    }
                    $(div).animate({ left: 0 }, interval);
                }
                // Search Submit
                headerSearch.submit(function (e) {
                    var s = $(this).find('input[type="text"]');
                    if (!s.val()) {
                        e.preventDefault();
                        shake($(this).find('input[type="text"]'));
                        $(this).find('input[type="text"]').focus();
                    }
                });
                /** END SHOW OR HIDE SEARCH BAR **/

                /** MASTHEAD PROGRESSIVE IMAGES **/
                var masthead = document.querySelector(".masthead"),
                    placeholderOverlay = document.querySelector(
                        ".placeholder-overlay"
                    );

                if (masthead && placeholderOverlay) {
                    // Load full size image. When loaded, fade our placeholder add it as bg to masthead
                    var img = new Image();
                    img.src = masthead.dataset.imageSrc;
                    img.onload = function () {
                        placeholderOverlay.classList.add("fade-out");
                        masthead.style.backgroundImage = "url(" + img.src + ")";
                    };
                }
                /** END MASTHEAD PRGRESSIVE IMAGES **/

                /** ANIMATED ANCHOR LINKS **/
                $('a[href*="#"]:not([href="#"])').click(function (e) {
                    if (!$(this).data("vc-container")) {
                        if (
                            location.pathname.replace(/^\//, "") ===
                                this.pathname.replace(/^\//, "") &&
                            location.hostname === this.hostname
                        ) {
                            var target = $(this.hash);
                            var $this = this;
                            var header = $("header.banner");
                            var wpAdminBar = $("#wpadminbar");
                            target = target.length
                                ? target
                                : $("[name=" + this.hash.slice(1) + "]");
                            if (target.length) {
                                $("html,body").animate(
                                    {
                                        scrollTop: target.offset().top,
                                    },
                                    500,
                                    function () {
                                        if (history.pushState) {
                                            history.pushState(
                                                null,
                                                null,
                                                $this.hash
                                            );
                                        } else {
                                            location.hash = $this.hash;
                                        }
                                    }
                                );
                                e.preventDefault();
                            }
                        }
                    }
                });
                /** END ANIMATED ANCHOR LINKS **/

                // General Slider
                var $visceralSlider = $(".visceral-slider");

                $visceralSlider.slick({
                    draggable: true,
                    dots: true,
                    infinite: true,
                    arrows: true,
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 6000,
                });

                // slick slide
                if ($(".programs-container").length > 0) {
                    var $programSlides = $(
                        ".programs-container .vc-custom-promo-box"
                    );
                    if ($programSlides.length) {
                        $programSlides.each(function () {
                            var $programSlideHeading =
                                $(this).find(".vc-promo-header");
                            $($programSlideHeading).clone().appendTo(this);
                            $(this).append(
                                '<div class="program-slide-bottom"><p class="h5 text-highlight">Program</p><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 6.22917H12.6042L7.625 1.25L8.875 0L16 7.10417L8.89583 14.2292L7.625 12.9583L12.6042 8H0V6.22917Z" fill="#C8102E"/></svg></div>'
                            );
                        });
                    }
                }

                /* NUMBER TICKER UPON VIEW */
                // IMPORTANT: Requires Waypoint.js and Counterup.js (Enqueued from JSDelivr)
                var numberTickers = $(".ticker");
                if (numberTickers.length) {
                    numberTickers.counterUp({
                        time: 700,
                    });
                }
                /* END NUMBER TICKER UPON VIEW */

                // Starts item reveal JS
                Sage.itemReveal();

                /* PAGE SUB NAV MOBILE ANIMATION */

                $(".page-sub-nav h5, .page-sub-nav .h5").on(
                    "click",
                    function () {
                        if ($(window).outerWidth() <= 768) {
                            $pageSubNav = $(this).closest(".page-sub-nav");
                            if ($pageSubNav.hasClass("active")) {
                                $pageSubNav.removeClass("active");
                            } else {
                                $pageSubNav.addClass("active");
                            }
                            $(this).next().slideToggle("swing");
                        }
                    }
                );

                /* SOCIAL QUOTE SHARE */

                $(".visceral_quote_share__quote").wrap(
                    '<div class="visceral_quote_share"></div'
                );
                $(".visceral_quote_share__quote").after(
                    '<div class="social-container"><span>Share</span><button class="social_quote_share icon-twitter link" data-social="twitter" title="Share on Twitter"></button><button class="social_quote_share icon-facebook link" data-social="facebook" title="Share on Facebook"></button></div>'
                );

                $(".social_quote_share").on("click", function (e) {
                    // Prevent default link open
                    e.preventDefault();
                    var this_el = $(this);
                    // Get quote text from blockquote
                    var quoteText = this_el
                        .closest(".visceral_quote_share")
                        .find("blockquote")
                        .html();
                    // Remove any html tags from string
                    quoteText = quoteText.replace(/<(?:.|\n)*?>/gm, "");
                    var link;
                    if (this_el.data("social") === "twitter") {
                        link =
                            "https://twitter.com/intent/tweet?text=" +
                            encodeURIComponent(quoteText) +
                            "&url=" +
                            encodeURIComponent(window.location.href);
                    } else if (this_el.data("social") === "facebook") {
                        var appId = "1651624958476965";
                        link =
                            "https://www.facebook.com/dialog/feed?app_id=" +
                            appId +
                            "&displaypopup&name=" +
                            encodeURIComponent(quoteText) +
                            "&description=" +
                            encodeURIComponent(document.title) +
                            "&link=" +
                            encodeURIComponent(window.location.href) +
                            "&redirect_uri=" +
                            encodeURIComponent(window.location.href);
                    }
                    return window.open(
                        link,
                        "",
                        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=640, height=440, top=0, left=0"
                    );
                });

                /* END SOCIAL QUOTE SHARE */

                /* FIXED PARALLAX IN PAGE BUILDER */

                var $fixedParallaxSections = $("section.fixed-parallax");

                // Make sure there is a fixed parallax section on the page
                if ($fixedParallaxSections) {
                    function fixedParallaxResize() {
                        // Find each fixed parallax section
                        $fixedParallaxSections.each(function () {
                            var $this = $(this);
                            // Get the next section
                            var $nextSection = $this.nextAll("section:first");
                            // Apply margin top to the next section to offset the fixed position of the parallax section
                            $nextSection.css({
                                "margin-top": $this.innerHeight(),
                            });
                        });
                    }
                    // Run on page load
                    fixedParallaxResize();

                    // Run on window resize
                    $(window).resize(fixedParallaxResize);
                }

                function transparentOnScroll() {
                    var st = $(window).scrollTop();

                    var $fixedSection = $(".fixed-parallax .vc_row ");
                    $fixedSection.css({ opacity: 1 - st / 400 });
                }

                $(window).scroll(transparentOnScroll);

                /** CENTERED TOTAL FOR ROUND VC CHART */
                if ($(".centered-total-chart").length > 0) {
                    $(".centered-total-chart").each(function () {
                        // Get all static legend elements
                        $(this)
                            .find("canvas")
                            .wrap(
                                '<div class="centered-total-chart__canvas-wrapper"></div>'
                            );

                        var $chartTotal = $(this).find(".chart-total").detach();

                        $chartTotal.appendTo(
                            $(this).find(
                                ".centered-total-chart__canvas-wrapper"
                            )
                        );
                        $(this)
                            .find(".rrj-preload-wrap")
                            .css("display", "none");
                    });
                }
                /** END CREATE COLOR-CODED LEGEND FOR ROUND VC CHART */

                /** FIXED SECTION BG VIDEO WITH IMAGE FADE */
                $(window).load(function () {
                    $vc_bg_video = $(".fixed-parallax .vc_video-bg");

                    // Check if the element is on the page
                    if ($vc_bg_video.length > 0) {
                        $vc_bg_video.hide();

                        // Wait 3 sec then fade in (to help with load)
                        setTimeout(function () {
                            $vc_bg_video.fadeIn("slow");
                        }, 3000);
                    }
                });

                /** END FIXED SECTION BG VIDEO WITH IMAGE FADE */
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            },
        },
        // Home page
        home: {
            init: function () {
                // JavaScript to be fired on the home page

                /** VIDEO BG */
                jQuery(function () {
                    jQuery(".player").YTPlayer();
                });
                /** VIDEO BG */
            },

            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS

                var $slickNext = $(".slick-next");
                var $slickArrows = $(".slick-arrow");

                if ($slickNext) {
                    $slickNext.addClass("slick-arrow--active");
                }

                if ($slickArrows) {
                    $slickArrows.on("mouseenter", function () {
                        $slickArrows.removeClass("slick-arrow--active");
                    });
                }
            },
        },
        // Programs Page JS
        programs: {
            init: function () {
                function fixedProgramAnchorNav() {
                    var programAnchorNav = $(".program-sub-menu");
                    var programAnchorNavOffset;
                    var windowScrollTop;
                    if (programAnchorNav.length > 0) {
                        programAnchorNavOffset = programAnchorNav.offset().top;
                        $(window).scroll(function () {
                            windowScrollTop = $(window).scrollTop();

                            if (windowScrollTop > programAnchorNavOffset) {
                                programAnchorNav.addClass(
                                    "program-sub-menu--fixed"
                                );
                            } else {
                                programAnchorNav.removeClass(
                                    "program-sub-menu--fixed"
                                );
                            }
                        });
                    }
                }

                fixedProgramAnchorNav();

                $(window).resize(function () {
                    fixedProgramAnchorNav();
                });

                $(".program-sub-menu li:first-child").addClass("active-anchor");

                // eslint-disable-next-line no-unused-vars
                var anchorLinks = $(".program-sub-menu a")
                    .map(function () {
                        // Essentially we're finding all the <a> tags in ".page__sub-nav" and running a function on each one
                        return this.href.substr(this.href.indexOf("#"));
                    })
                    .toArray(); // toArray takes all of these results and pushes them into an array

                function activeAnchorNav() {
                    if ($(window).innerWidth() > 768) {
                        var scrollTop = $(window).scrollTop();
                        // This code runs inside stickynavSetup which means it runs anytime the page loads or the user scrolls
                        // eslint-disable-next-line no-unused-vars
                        var activeState = ""; // create a variable to store the active state

                        // The for loop cycles through all the links in anchorLinks
                        for (var i = 0; i < anchorLinks.length; i++) {
                            // Create a variable for the sub-nav link
                            var sbLink = anchorLinks[i]; // Will return #vision (or #overview, etc.)
                            // Create a variable for the position of the corresponding anchor link.  I.e. if the link is "#overview" we're looking for an anchor named "overview"
                            var anchorPos = $(sbLink).offset().top; // The substring(1) function just trims the first character so we're getting top offset value of #overview
                            if (scrollTop >= anchorPos) {
                                // if our current scroll position is greater than the position of the corresponding anchor
                                activeState = sbLink;
                            }
                        }

                        if (
                            !$('a[href="' + activeState + '"]')
                                .parent("li")
                                .hasClass("active-anchor")
                        ) {
                            $(".program-sub-menu li").removeClass(
                                "active-anchor"
                            );
                            var $activeSection = $(
                                'a[href="' + activeState + '"]'
                            );
                            if ($activeSection.length) {
                                $activeSection
                                    .parent("li")
                                    .addClass("active-anchor");
                            }
                        }
                    }
                }
                $(window).load(function () {
                    activeAnchorNav();
                });
                $(window).scroll(function () {
                    activeAnchorNav();
                });
            },
        },
        // News & Ideas page
        page_template_template_news_ideas: {
            init: function () {
                // JavaScript to be fired on the News & Ideas page

                // If there is a background video for masthead, this checks if it's YouTube or Vimeo and then uses the right library
                var bgVideoProperties = $("#bgndVideo").data("property");
                var mastheadVideo;
                var videoType;
                if (bgVideoProperties != null) {
                    if (bgVideoProperties.indexOf("vimeo") !== -1) {
                        mastheadVideo = $("#bgndVideo").vimeo_player();
                        videoType = "vimeo";
                    } else {
                        mastheadVideo = $("#bgndVideo").YTPlayer();
                        videoType = "youtube";
                    }
                }

                var mastheadButton = $(".masthead-button");

                if (mastheadButton.length > 0) {
                    mastheadButton.on("click", function () {
                        if ("playing" === $(this).attr("data-state")) {
                            if (videoType === "youtube") {
                                mastheadVideo.YTPPause();
                            }
                            if (videoType === "vimeo") {
                                mastheadVideo.v_pause();
                            }
                            $(this).attr("data-state", "paused");
                            $(this).find("span:first-child").text("Play Video");
                            $(this)
                                .find("span:last-child")
                                .html(
                                    '<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6.5L0.75 12.9952L0.75 0.00480938L12 6.5Z" fill="white"/></svg>'
                                );
                        } else {
                            if (videoType === "youtube") {
                                mastheadVideo.YTPPlay();
                            }
                            if (videoType === "vimeo") {
                                mastheadVideo.v_play();
                            }
                            $(this).attr("data-state", "playing");
                            $(this)
                                .find("span:first-child")
                                .text("Pause Video");
                            $(this)
                                .find("span:last-child")
                                .html(
                                    '<svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2038_6673)"><path d="M0 0H3.36842V12H0V0ZM5.63158 0H9V12H5.63158V0Z" fill="white" /></g><defs><clipPath id="clip0_2038_6673"><rect width="9" height="12" fill="white" /></clipPath></defs></svg>'
                                );
                        }
                    });
                }
            },
        },
        // News & Ideas Sub page
        page_template_template_news_ideas_sub: {
            init: function () {
                // JavaScript to be fired on the News & Ideas page

                // If there is a background video for masthead, this checks if it's YouTube or Vimeo and then uses the right library
                var bgVideoProperties = $("#bgndVideo").data("property");
                var mastheadVideo;
                if (bgVideoProperties != null) {
                    if (bgVideoProperties.indexOf("vimeo") !== -1) {
                        mastheadVideo = $("#bgndVideo").vimeo_player();
                    } else {
                        mastheadVideo = $("#bgndVideo").YTPlayer();
                    }
                }

                var mastheadButton = $(".masthead-button");

                if (mastheadButton.length > 0) {
                    mastheadButton.on("click", function () {
                        if ("playing" === $(this).attr("data-state")) {
                            mastheadVideo.YTPPause();
                            $(this).attr("data-state", "paused");
                            $(this).find("span:first-child").text("Play Video");
                            $(this)
                                .find("span:last-child")
                                .html(
                                    '<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6.5L0.75 12.9952L0.75 0.00480938L12 6.5Z" fill="white"/></svg>'
                                );
                        } else {
                            mastheadVideo.YTPPlay();
                            $(this).attr("data-state", "playing");
                            $(this)
                                .find("span:first-child")
                                .text("Pause Video");
                            $(this)
                                .find("span:last-child")
                                .html(
                                    '<svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2038_6673)"><path d="M0 0H3.36842V12H0V0ZM5.63158 0H9V12H5.63158V0Z" fill="white" /></g><defs><clipPath id="clip0_2038_6673"><rect width="9" height="12" fill="white" /></clipPath></defs></svg>'
                                );
                        }
                    });
                }

                /* AJAX LOAD AND FILTER */
                // Global Variables
                var $loadMore = $("#load-more button");
                var totalPosts = $("#total-posts-count").data("total-posts");
                var $container = $(".posts-list .row");
                var $postsList = $(".posts-list");
                var queryVars = visceral_vars.query_vars;
                var offset = visceral_vars.query_vars.posts_per_page;
                var i = 1;
                // console.log(visceral_vars);

                // Function for load more
                function ajaxLoadPosts() {
                    // Increase the offset by posts_per_page for load more function
                    offset = visceral_vars.query_vars.posts_per_page * i;
                    // Run check filter on topic inputs
                    var topicFilter = $("#post_topic-dropdown");
                    // get value from dropdown
                    topicFilter = topicFilter.val();

                    $.ajax({
                        url: visceral.ajaxurl,
                        type: "post",
                        data: {
                            action: "ajax_load_posts",
                            security: visceral_vars.security,
                            query_vars: queryVars,
                            offset: offset,
                            topic_filter: topicFilter,
                            page_type: visceral_vars.page_type,
                        },
                        beforeSend: function () {
                            $postsList.addClass("loading");
                        },
                        complete: function () {
                            $postsList.removeClass("loading");
                            Sage.itemReveal();
                        },
                        success: function (jsonData) {
                            var data = JSON.parse(jsonData);

                            $loadMore.blur();
                            $container.append(data.posts);

                            // Get Number of posts in container
                            var $containerChildren =
                                $container.children().length;
                            // Check to see if we have the total number of posts we can get. If we do, hide the load more button
                            if ($containerChildren >= totalPosts) {
                                $loadMore.hide();
                                // If not, make sure the load more is visible
                            } else {
                                if (!$loadMore.is(":visible")) {
                                    $loadMore.show();
                                }
                            }
                            i++;
                        },
                    });
                }

                $loadMore.on("click", function (e) {
                    e.preventDefault();
                    ajaxLoadPosts();
                });

                var topicFilter = "";

                function ajaxFilterPosts() {
                    // Reset iterator
                    i = 1;
                    // Reset offset
                    offset = 0;
                    // Run check filter on topic inputs
                    var topicFilter = $("#post_topic-dropdown");
                    // get value from dropdown
                    topicFilter = topicFilter.val();
                    // console.log(queryVars);

                    $.ajax({
                        // This is admin-ajax.php
                        url: visceral.ajaxurl,
                        type: "post",
                        data: {
                            // This is a php function that runs new query
                            //  All of this data is sent to the php function so it can use the variables
                            action: "ajax_load_posts",
                            security: visceral_vars.security,
                            query_vars: queryVars,
                            offset: offset,
                            topic_filter: topicFilter,
                            page_type: visceral_vars.page_type,
                        },
                        beforeSend: function () {
                            $postsList.addClass("loading");
                        },
                        complete: function () {
                            $postsList.removeClass("loading");
                            // Re-run itemReveal so that items fade in on scroll
                            Sage.itemReveal();
                        },
                        success: function (jsonData) {
                            //  This is the response back from the php function
                            var data = JSON.parse(jsonData);
                            // console.log(data);
                            // Update the total posts data from the new query
                            $("#total-posts-count").attr(
                                "data-total-posts",
                                data.total_posts
                            );
                            // Remove all posts and add in what was retrieved from new query
                            $container.empty();
                            $container.prepend(data.posts);
                            // Set totalPosts variable to new total posts data
                            totalPosts = data.total_posts;
                            var $containerChildren =
                                $container.children().length;
                            // // Check to see if we need to show or hide the load more button (if there are more posts)
                            if (
                                $containerChildren < totalPosts &&
                                !$loadMore.is(":visible")
                            ) {
                                $loadMore.show();
                            } else if ($containerChildren >= totalPosts) {
                                $loadMore.hide();
                            }
                            // Adds query string to url for link sharing
                            var queryString = "";

                            // If there is a topic filter
                            if (topicFilter) {
                                queryString += "topic_filter=" + topicFilter;
                            }

                            // Add query string to url
                            var pageUrl = "?" + queryString;
                            window.history.pushState("", "", pageUrl);
                        },
                        error: function (
                            MLHttpRequest,
                            textStatus,
                            errorThrown
                        ) {
                            alert(errorThrown);
                        },
                    });
                }

                // Run AJAX request when submit button clicked
                $("#post_topic-dropdown").on("change", function (e) {
                    // Don't actually submit form
                    e.preventDefault();

                    // Removes exclusion of featured content when filter is run (to include that content if they
                    // meet the filter criteria)
                    visceral_vars.query_vars.post__not_in = [];

                    // Run AJAX request
                    ajaxFilterPosts();
                });
            },
        },
        grants: {
            init: function () {
                // JavaScript to be fired on the Grants page

                /** CREATE COLOR-CODED LEGEND FOR ROUND VC CHART */
                $(".grant-chart").each(function () {
                    // Get data from chart
                    var chartData = JSON.parse(
                        $(this).find(".chart-data").html()
                    );
                    var chartColors =
                        chartData.data.datasets[0].hoverBackgroundColor;
                    var chartDataValues = chartData.data.datasets[0].data;

                    var chartDataValuesTotal = 0;

                    chartDataValues.forEach(function (item, index) {
                        chartDataValuesTotal += item;
                    });

                    // Get all static legend elements
                    var programLegends = $(this).find(
                        ".chart-program-legend .wpb_wrapper"
                    );

                    // Iterate through each legend element
                    $i = 0;
                    programLegends.each(function () {
                        var $this = $(this);
                        // Add some inner elements for layout
                        $this.wrapInner(
                            '<div class="chart-program-inner"><div class="chart-program-main"></div></div>'
                        );
                        // Give the label the color from the chart (in order)
                        $this
                            .children(".chart-program-inner")
                            .prepend(
                                '<div class="chart-program-label" style="background-color:' +
                                    chartColors[$i] +
                                    ';"></div>'
                            );
                        $i++;
                    });

                    $(this)
                        .find("#chart-program-total div.h3")
                        .html(
                            '$<span class="ticker">' +
                                chartDataValuesTotal.toLocaleString() +
                                "</span>"
                        );
                });

                // Keyboard accessibility for links
                $(".chart-program-legend a").focusin(function () {
                    $(this).closest("p").prev("p").css("opacity", "0");
                });

                $(".chart-program-legend a").focusout(function () {
                    $(this).closest("p").prev("p").css("opacity", "1");
                });

                /** END CREATE COLOR-CODED LEGEND FOR ROUND VC CHART */
            },
        },
        search_our_grants: {
            init: function () {
                // JavaScript to be fired on the Search Our Grants page

                /* GRANTEE GRANTS OPEN ANIMATION */
                $(".grantee-header").on("click", function () {
                    $(this).closest(".grantee").toggleClass("active");
                    $(this).next().slideToggle();
                });
            },
        },
        single: {
            init: function () {
                // JavaScript to be fired on the Single posts

                // Only do this on single posts or single resources
                if ($("body").is(".single-post, .single-resource")) {
                    /* Fixed Social Share on Scroll */
                    // Setup variables
                    // The element we want to fix
                    var $socialShare = $(".social-share-container"),
                        // The container
                        $container = $("#main-content .container");

                    function fixSocialSetUp() {
                        // Distance the user has scrolled
                        scrollTop = $(window).scrollTop();
                        // How far the top of the element is from the top of document
                        (shareOffset = $socialShare.offset().top),
                            // Bottom of the container element
                            (containerOffset =
                                $container.offset().top +
                                $container.outerHeight()),
                            //How far the share is from the top of the window (changes when scrolled)
                            (shareDistance = shareOffset - scrollTop);
                        containerDistance = containerOffset - scrollTop;
                    }

                    function fixSocialShare() {
                        // Only do this if not mobile
                        if (window.innerWidth > 768) {
                            // Set variables that change on scroll
                            scrollTop = $(window).scrollTop();
                            shareDistance = shareOffset - scrollTop;
                            containerDistance = containerOffset - scrollTop;

                            // If the distance we've scrolled is greater than or equal to the distance to the top, add a fixed class
                            if (
                                scrollTop >=
                                shareDistance + (shareOffset - 85)
                            ) {
                                $socialShare.addClass("fixed");
                            } else {
                                $socialShare.removeClass("fixed");
                            }

                            if (
                                containerDistance <=
                                $socialShare.outerHeight() + 75
                            ) {
                                $socialShare.addClass("below");
                            } else {
                                $socialShare.removeClass("below");
                            }
                        }
                    }
                    // Run function on document ready
                    fixSocialSetUp();
                    fixSocialShare();
                    // Run function on window scroll
                    $(window).scroll(fixSocialShare);
                    // Run function on window resize
                    $(window).resize(fixSocialSetUp);

                    /* End Fixed Social Share on Scroll */
                }

                // If post has background video for masthead, this checks if it's YouTube or Vimeo and then uses the right library
                var bgVideoProperties = $("#bgndVideo").data("property");
                if (bgVideoProperties != null) {
                    if (bgVideoProperties.indexOf("vimeo") !== -1) {
                        $("#bgndVideo").vimeo_player();
                    } else {
                        $("#bgndVideo").YTPlayer();
                    }
                }
            },
        },
        single_person: {
            init: function () {
                $relatedPosts = $(".related-posts .list-item");
                $relatedPostsButton = $(".related-posts .btn");

                if ($relatedPosts.length > 6) {
                    $relatedPosts.each(function (i) {
                        if (i > 5) {
                            $(this).addClass("related-item-hidden").hide();
                        }
                    });
                    $relatedPostsButton.html("View All");

                    $relatedPostsButton.on("click", function (e) {
                        e.preventDefault();
                        $(".related-item-hidden").fadeIn();
                        $(this).hide();
                    });
                }
            },
        },
        page_template_template_video_modal_page: {
            init: function () {
                $(".video-modal-popup").magnificPopup({
                    type: "iframe",
                    iframe: {
                        markup:
                            '<div class="mfp-iframe-scaler">' +
                            '<div class="mfp-close"></div>' +
                            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                            '<div class="mfp-title">Some caption</div>' +
                            "</div>",
                    },
                });
            },
        },
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = funcname === undefined ? "init" : funcname;
            fire = func !== "";
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === "function";

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire("common");

            // Fire page-specific init JS, and then finalize JS
            $.each(
                document.body.className.replace(/-/g, "_").split(/\s+/),
                function (i, classnm) {
                    UTIL.fire(classnm);
                    UTIL.fire(classnm, "finalize");
                }
            );

            // Fire common finalize JS
            UTIL.fire("common", "finalize");
        },
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
